import React from "react";
import Top_bar from "../../Components/topBar/topBar";
import AddMachine from "../Registration/Machine/addMachine";
import AltMachine from "../Registration/Machine/altMachine";
import DelMachine from "../Registration/Machine/delMachine";
import { Tab, Row, Col, ListGroup } from "react-bootstrap";
import TableList from "../../Components/tableList/TableList";
import Alert from "../../Components/alert/Alert";
import Api from "../../services/api";
import "./prelude.css";
import "../../Components/reports/reports.css";
import MessageTable from "../../Components/messageTable/MessageTable";
import BottomBar from "../../Components/bottomBar/bottomBar";
import { handleColor } from "../../services/Functions";
import ReportMachines from "../Reports/reportMachines";
import { DrawerMenu } from "../../Components/DrawerMenu/DrawerMenu";

const prelude_machine = () => {
  const [activeTab, setActiveTab] = React.useState("list");
  return (
    <>
      <header>
        <Top_bar />{" "}
      </header>
      <div className="prelude_container">
        <DrawerMenu>
          <Sidebar
            isMobile
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          ></Sidebar>
        </DrawerMenu>
        <Sidebar activeTab={activeTab} setActiveTab={setActiveTab}></Sidebar>
      </div>
      <BottomBar></BottomBar>
    </>
  );
};

class Sidebar extends React.Component {
  state = { data: [], keys: [], render: false, message: "", click: false };

  async componentDidMount() {
    let array = [];
    await Api.get("/machines")
      .then((response) => {
        response.data.forEach(({ description, code, factory, department }) => {
          array.push({
            Máquina: description + code,
            ["Planta"]: factory.factory_name,
            Setor: department,
          });
        });
        if (array.length > 0) this.setState({ data: array, render: true });
      })
      .catch((err) => {
        this.setState({ message: "" });
      });
  }

  handleClick = () => {
    if (this.props.click === false) {
      this.setState({ click: true });
      return true;
    } else {
      this.setState({ click: false });
      return false;
    }
  };

  render() {
    const { show, message } = this.state;
    const items = [
      { id: "lg1", label: "Máquinas", eventKey: "list" },
      { id: "lg2", label: "Adicionar Máquina", eventKey: "add" },
      { id: "lg3", label: "Alterar Máquina", eventKey: "alt" },
      { id: "lg4", label: "Deletar Máquina", eventKey: "del" },
    ];

    return (
      <Tab.Container activeKey={this.props.activeTab}>
        <Row style={{ width: "100%", height: "100%" }}>
          <div className="sidebar1">
            <div
              className={this.props.isMobile ? "sidebar2-mobile" : "sidebar2"}
            >
              <Col className="sidebarColumn" mountOnEnter unmountOnExit>
                <ListGroup>
                  {items.map((item) =>
                    this.props.isMobile ? (
                      <Col key={item.id} xs={12}>
                        <ListGroup.Item
                          id={item.id}
                          onClick={() => {
                            this.props.setActiveTab(item.eventKey);
                            this.props.handleClose();
                          }}
                          className="listGroup"
                          eventKey={item.eventKey}
                        >
                          {item.label}
                        </ListGroup.Item>
                      </Col>
                    ) : (
                      <ListGroup.Item
                        key={item.id}
                        id={item.id}
                        onClick={() => {
                          this.props.setActiveTab(item.eventKey);
                        }}
                        className="listGroup d-none d-md-block"
                        eventKey={item.eventKey}
                      >
                        {item.label}
                      </ListGroup.Item>
                    )
                  )}
                </ListGroup>
              </Col>
            </div>

            <Col
              className="col3"
              style={{
                top: "5%",
                marginLeft: "1.5%",
                width: "100%",
                height: "80vh",
              }}
            >
              {show ? (
                <Alert
                  show={show}
                  message={message}
                  parentCallback={this.callbackfunction}
                />
              ) : null}
              <Tab.Content>
                <Tab.Pane eventKey="list">
                  {this.handleClick ? <ReportMachines /> : null}
                </Tab.Pane>
                <Tab.Pane mountOnEnter unmountOnExit eventKey="add">
                  {this.handleClick ? <AddMachine /> : null}
                </Tab.Pane>
                <Tab.Pane mountOnEnter unmountOnExit eventKey="alt">
                  {this.handleClick ? <AltMachine /> : null}
                </Tab.Pane>
                <Tab.Pane mountOnEnter unmountOnExit eventKey="del">
                  {this.handleClick ? <DelMachine /> : null}
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </div>
        </Row>
      </Tab.Container>
    );
  }
}

export default prelude_machine;
